<template>
  <div>
      <h2 class="mt-5">Upload Ownership Data</h2>
      <ExcelVue :sheet="sampleExcel" :fname="filename"/>
 
  </div>
</template>

<script>
import ExcelVue from "@/components/ExcelOwnership.vue";

export default {
  components: {
    ExcelVue,
   
},
  data() {
    return {
      file: null,
      filename:"FormOwneship.xlsx",
      sampleExcel:[{ 
                    name: "SheetOne",  
                    data: [ 
                            {
                              "admin_hub_code":"SUB-01",
                              "ph_name":"PH Surabaya",
                              "Ownership":"paxel home"
                            }        
                          ] 
                    }],
     
    };
  },
  methods: {
    onChange(event) {
      this.file = event.target.files ? event.target.files[0] : null;
    },
    test(){}

  },
  mounted(){
    
  }
 
};
</script>
<style scoped>
input[type="file"] {
    width: 50%;
    border: 1px solid black;
    padding: 5px 25px;
    border-radius: 5px;
}
</style>
